import angular from 'angular';
import { ThankyouComponent } from './thankyou.component';
export default angular.module('eeComUiApp.thankyou', [])
    .component('thankyou', ThankyouComponent)
    .name;
//# sourceMappingURL=index.js.map